import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import CoursePopup from "./CoursePopup";
import { VodPlay } from "./Curriculum";
import LectureVideo from "./LectureVideo";
import KlassPurchaseButton from "./KlassPurchaseButton";

import { Course, Progress } from "types/klass";
import { discountedRate } from "utils/util";

type LectureFooterProps = {
  course: Course;
  progress?: Progress;
  promotionTxt: string;
  defaultCourseId: string | undefined;
};

const LectureFooter: React.FC<LectureFooterProps> = ({
  course,
  progress,
  promotionTxt,
  defaultCourseId,
}) => {
  const { id } = useParams();
  const [vodPopup, setVodPopup] = useState<VodPlay>({
    popup: false,
    bookmark: 0,
    lectureId: "",
  });
  const [coursePopup, setCouresPopup] = useState<string>("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chapterId = params.get("chapterId");
  const lectureId = params.get("lectureId");

  return (
    <div className="fixed bottom-0 left-0 right-0 shadow-footer py-[15px] bg-[#fff] z-[91] px-4 lg:mb-6">
      {vodPopup.popup && (
        <LectureVideo
          courseId={id as string}
          chapterId={chapterId as string}
          lectureId={lectureId as string}
          setPopup={setVodPopup}
          bookmark={vodPopup.bookmark}
          progressPercent={progress?.progressPct}
        />
      )}
      {coursePopup && <CoursePopup title={course.title} setPopup={setCouresPopup} />}
      <div className="flex items-center justify-between space-x-5">
        <div className="w-[65%]">
          <div className="break-all overflow-hidden text-ellipsis line-clamp-2 lg:line-clamp-1 text-gray-900 text-[15px] lg:text-[20px] font-semibold">
            {course?.title}
          </div>
          <div className="hidden lg:block">{promotionTxt}</div>
        </div>
        <div className="flex items-center justify-center space-x-2">
          <div className="flex items-center justify-between">
            {course.products.length > 0 && (
              <div className="text-medi-color-purple-600 text-[25px] mr-5 font-semibold hidden lg:block w-52 text-right">
                {discountedRate(
                  course?.products[0]?.regularPrice,
                  course?.products[0]?.salePrice,
                ) !== 0 &&
                  !course.isFree && (
                    <span className="text-alert mr-2">
                      {discountedRate(
                        course?.products[0]?.regularPrice,
                        course?.products[0]?.salePrice,
                      )}
                      %
                    </span>
                  )}
                {course.isFree ? "0" : course?.products[0]?.salePrice.toLocaleString()}원
              </div>
            )}
          </div>
          <div className="w-[88px] h-10 lg:w-[190px] lg:h-[60px] lg:text-[25px]">
            <KlassPurchaseButton
              simple
              course={course}
              progress={progress}
              defaultCourseId={defaultCourseId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LectureFooter;
